// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"550":"71f2a5f8","787":"75867dd5","921":"1c65b4ee"}[chunkId] + ".chunk.js";
};